type DeadlineCalloutProps = {
  message: string
}

export function DeadlineCallout({ message }: DeadlineCalloutProps) {
  return (
    <div className="flex items-center gap-2">
      <div className="w-[2px] h-[29px] shrink-0 rounded-full bg-[#D9892B]" />
      <span className="text-[13px] font-[500] text-[#D9892B] leading-[150%]">{message}</span>
    </div>
  )
}
